import React, { useState } from "react";
import "../../style/LoginForm.css";
import { FaUser, FaLock } from "react-icons/fa";
import logo from "../assets/logo.png";
import github from "../assets/Github.png";
import google from "../assets/Google.png";
import linkedin from "../assets/LinkedIn.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext"; 

const LoginForm = () => {
    const navigate = useNavigate();
    const { login } = useAuth(); // Get login function from context
    const API_BASE_URL = process.env.REACT_APP_API_SOURCE;
    const suspiciousPattern = /('|--|;|<script|<img|onerror=|onload=|select\s|insert\s|drop\s|union\s)/i;
    console.log("API_BASE_URL:", API_BASE_URL); // Debugging log

    const [formData, setFormData] = useState({
      username: "",
      password: "",
    });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
      setFormData({...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setError("");
      setLoading(true);
    
      console.log("Sending data: ", JSON.stringify(formData));
      if (suspiciousPattern.test(formData.username) || suspiciousPattern.test(formData.password)) {
        setError("Haha, goodluck trying to injection attack in the form inputs!");
        setLoading(false);
        return;
      }
      
      try {
        const response = await fetch(`${API_BASE_URL}/backend/api/LoginForm/login.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
    
        const result = await response.json();
        console.log("Server Response: ", result);
    
        setLoading(false);
    
        if (result.status === "success" && result.userId) {

          login(result.userId); // ✅ Store userId
          navigate("/home"); // ✅ Redirect to homepage
        } else {
          setError(result.message);
        }
      } catch (error) {
        console.error("Sign In error: ", error);
        setError("An error occurred. Please try again.");
        setLoading(false);
      }
    };
        
    return (
      <div className="login-container">
        <div className="login-box">
          {/* ✅ Match logo to Figma */}
          <div className="logo-container">
            <img src={logo} alt="LockedIn Logo" className="logo" />
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-box">
              <input type="text" placeholder="Username" name="username" onChange={handleChange} required />
              <FaUser className="icon" />
            </div>

              {/* Prevents copy-paste and adds an option to toggle view password */}
              <div className="input-box">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  onChange={handleChange}
                  onPaste={(e) => e.preventDefault()}
                  required
                />
                <FaLock className="icon" />
                <span
                  className={`toggle-password ${showPassword ? "visible" : ""}`}
                  onClick={() => setShowPassword((prev) => !prev)}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <svg
                      className="eye-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10a9.958 9.958 0 011.385-5.015M9.879 4.122a4.002 4.002 0 014.242 6.753m-1.743-1.743a4.002 4.002 0 01-4.242-6.753M3 3l18 18"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="eye-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm-6.906 6.032A9.961 9.961 0 012 12c2.086-3.985 6.124-6.5 10-6.5s7.914 2.515 10 6.5a9.961 9.961 0 01-6.094 6.032M4.93 4.93l14.14 14.14"
                      />
                    </svg>
                  )}
                </span>
              </div>

            {error && <p className="error">{error}</p>}
            {/* ✅ Position Forgot Password correctly */}
            <div className="forgot-password">
              <a onClick={() => { console.log("navigating to forgot-password...") ; navigate("/forgot-password");}} className="forgot-password">
                Forgot Password?
              </a>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>

          <div className="external-login-section">
            <p>or continue with:</p>
            <div className="external-login">
              <a href="https://github.com/login">
                <img src={github} alt="Github" />
              </a>
              <a href="https://accounts.google.com/signin">
                <img src={google} alt="Google" />
              </a>
              <a href="https://www.linkedin.com/login">
                <img src={linkedin} alt="LinkedIn" />
              </a>
            </div>
          </div>

          <div className="register-link">
            <p>Don't have an account? <span onClick={() => navigate("/register")} className="register-text">Register</span></p>
          </div>
        </div>
      </div>
    );
};

export default LoginForm;